import React from 'react';
import Select from 'react-select';
import { Accordion, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { customStylesForOCP, ColumnValues } from '../../../../../Components/helper';
import { ChevronIcon } from '../../../../../bombiix-icon';
import { NewInput } from '../../../../../Components/PIM/common/NewInput';
import { NewCheckbox } from '../../../../../Components/PIM/common/NewCheckbox';

export function NumberPerConfig({ obj, onChange, colourSwitch, forSwitch, chcekingFromDynamicArray, controlKey }) {
  const { t } = useTranslation('common');
  return (
    <div className="p-2">
      <Accordion key={`Column_${0}`}>
        <Card className="rounded-0 ">
          <Card.Header className="d-flex align-items-center bgcolor-dark rounded-0 py-1 px-2">
            <div className="d-flex p-2 align-items-center reducing-switch-z-index">
              <div className="custom-control custom-switch line-h-initial">
                <NewCheckbox className="custom-control-input" id="colourSwitch_" name="colourSwitch_" onChange={(e) => forSwitch(e)} checked={colourSwitch} />
                <label className="custom-control-label p-0" htmlFor="colourSwitch_">
                  {t('CUSTOM_MODULE.COLOR_CODING')}
                </label>
              </div>
            </div>
            <span className="ml-auto">
              <ChevronIcon size={24} />
            </span>
          </Card.Header>
          {colourSwitch && (
            <Card.Body>
              <div className="flex-fill">
                {obj?.colourArray?.map((element, index) => {
                  return (
                    <div className="d-flex align-items-center f-14 mb-2" key={element}>
                      <div className="status-color-container d-flex">
                        <span className={`${element?.colourType} rount-shape`} />
                      </div>
                      <div className="d-flex flex-wrap align-items-center">
                        <span className="px-2 text-nowrap">if</span>
                        <div className="w-180 px-2 my-1 my-md-0">
                          <Select
                            name="colourValue"
                            options={ColumnValues?.filter((ele) => !obj?.colourArray?.map((e) => e?.colourValue)?.includes(ele?._id))}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option._id}`}
                            menuPlacement="bottom"
                            menuPosition="fixed"
                            isClearable
                            menuShouldBlockScroll
                            menuShouldScrollIntoView
                            value={chcekingFromDynamicArray(ColumnValues, element?.colourValue) || null}
                            styles={customStylesForOCP}
                            maxMenuHeight={140}
                            onChange={(e) => onChange(e, 'colourValue', index)}
                            placeholder="Select Value "
                          />
                        </div>
                        <NewInput
                          className="text-bordered percentaage-input mx-2"
                          onChange={(e) => onChange(e?.target?.value, 'startPercentage', index)}
                          disabled={!element?.colourValue}
                          value={element?.startPercentage}
                          name={`colourStateValue_start_${index}`}
                          type="number"
                        />{' '}
                        {controlKey === 'Number_Percentage' && '%'}
                        {element?.colourValue === 'between' && (
                          <div className="d-flex align-items-center ml-1">
                            {' and '}
                            <NewInput
                              className="text-bordered percentaage-input mx-2"
                              onChange={(e) => onChange(e?.target?.value, 'endPercentage', index)}
                              disabled={!element?.colourValue}
                              value={element?.endPercentage}
                              name={`colourStateValue_end_${index}`}
                              type="number"
                            />{' '}
                            {controlKey === 'Number_Percentage' && '%'}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Card.Body>
          )}
        </Card>
      </Accordion>
    </div>
  );
}

export default NumberPerConfig;
